import type React from 'react'

interface IInlineSpinnerProps {
    /** Lado em px (padrão 16, o mesmo do radio `w-4 h-4`: trocar um pelo outro não mexe no layout). */
    size?: number
    className?: string
}

/**
 * Indicador de carregamento dentro de uma linha de texto, em CSS (borda com `animate-spin`); a cor vem do texto em volta
 * (`border-current`). O `LoadingSpinner` é uma imagem de 100 px, para a página inteira. Decorativo (`aria-hidden`): quem
 * usa anuncia o andamento (ex.: `role="status"`).
 */
const InlineSpinner: React.FC<IInlineSpinnerProps> = ({ size = 16, className = '' }) => (
    <span
        aria-hidden="true"
        className={`inline-block border-2 rounded-full border-current border-t-transparent animate-spin ${className}`}
        style={{ width: size, height: size }}
    />
)

export default InlineSpinner
